import { Box, CircularProgress, Divider, Grid, ImageList, ImageListItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import WSButton from "../../Components/Button/WSButton";
import config from "../../Config/config.json";
import { callAPI, dateFormat, formatIndianCurrency, getLocalValue, LoacalVariables, Method, toBoolean } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { NotFound } from "../NotFound";
import logo from '../../images/logo.svg'
import { IBranch } from "../DTO/Dto";

const QPrint: React.FC = () => {
  const { id } = useParams();
  const contentRef = useRef<HTMLDivElement>(null);
  const { showMessage } = useSnackbar();

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [branchData, setBranchData] = useState<IBranch>()
  const paymentStages: any = data?.paymentTerms

  useEffect(() => {
    async function getDataById() {
      try {
        const response: any = await callAPI("quotations", Method.GET, null, id);
        console.log("Quotation Data:", response);
        if (response?.data) {
          setData(response.data);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
    async function getBranchDetails() {
      try {
        const response: any = await callAPI("Branch", Method.GET, null, getLocalValue(LoacalVariables.Branch));
        if (response?.data) {
          setBranchData(response.data);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
    if (id) {
      getDataById();
      getBranchDetails()
    }
  }, [id]);

  const handlePrint = useReactToPrint({
    contentRef
  });


  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  if (!data) return <NotFound />;
  // const bank1 = [
  //   ["Account Holder", "EVER SHINECEMENT PRODUCT"],
  //   ["Bank Name", "MADAI COOPERATIVE BANK"],
  //   ["A/c No.", "6441"],
  //   ["Branch", "ERIAM"],
  //   ["IFSC", ""],
  //   ["G Pay No.", "97 47 535 535 (MHB JOSEPH)"]
  // ];
  const bank1: [string, string][] = [
    ["Account Holder", data?.bankDetail?.bankHolderName],
    ["Bank Name", data?.bankDetail?.bankName],
    ["A/c No.", data?.bankDetail?.accountNumber],
    ["Branch", data?.bankDetail?.branchName],
    ["IFSC", data?.bankDetail?.ifscCode],
    ["G Pay No.", data?.bankDetail?.gpay],
  ];

  const bank2 = [
    ["Account Holder", "MARTIN INDUSTRIES"],
    ["Bank Name", "FEDERAL BANK"],
    ["A/c No.", "11270200020614"],
    ["Branch", "THALIPARAMBA"],
    ["IFSC", "FDRL0001127"],
    ["G Pay No.", "97 47 535 535 (MHB JOSEPH)"]
  ];
  const renderTable = (details: string[][]) => (
    <TableContainer sx={{ borderRadius: 2, boxShadow: 1 }}>
      <Table size="small">
        <TableBody>
          {details.map(([label, value], index) => (
            <TableRow
              key={index}
              sx={{ bgcolor: index % 2 ? "grey.100" : "white" }}
            >
              <TableCell sx={{ fontWeight: 500, fontSize: '0.75rem' }}> <Typography sx={{ fontSize: '0.75rem' }}>{label}:</Typography></TableCell>
              <TableCell align="right"> <Typography sx={{ fontSize: '0.75rem' }}>{value}</Typography></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const totalAmount = data.quotationItems
    .reduce((sum: number, item: any) => sum + Number(item.totalPrice || 0), 0)
    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // raw number
  const totalIncludedAmount = data.quotationItems
    .filter((item: any) => item.isIncluded)
    .reduce((sum: number, item: any) => sum + Number(item.totalPrice || 0), 0);

  // formatted for UI
  const totalIncludedAmountFormatted = totalIncludedAmount.toLocaleString(
    undefined,
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  );
  const totalInluded = data.quotationItems
    .filter((item: any) => item.isIncluded)
    .reduce((sum: number, item: any) => sum + Number(item.unitPrice * item?.quantity), 0)
    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const totalExcluded = data.quotationItems
    .filter((item: any) => !item.isIncluded)
    .reduce((sum: number, item: any) => sum + Number(item.unitPrice * item?.quantity), 0)
    .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      p={4}
      bgcolor="grey.100"
      minHeight="100vh"
    >
      <WSButton
        id="printBtn"
        size="small"
        label="Print Quotation"
        onClick={handlePrint}
      />

      <Box
        ref={contentRef}
        mt={2}
        sx={{ p: 4, width: "100%", maxWidth: "800px", bgcolor: "white" }}
      > <Box ml={2} display={'flex'} justifyContent={'flex-end'}>
          <img src={logo} alt="Company Logo" style={{ objectFit: "contain" }} />
        </Box>
        {/* Company Header */}
        <Box textAlign="center" borderBottom={1} pb={2} mb={2}>
          <Typography variant="h4" fontWeight="bold" color="error" fontStyle={'italic'}>
            {branchData?.name}
          </Typography>
          <Typography variant="body2">
            {branchData?.address?.addressLine1 || ''}  {branchData?.address?.addressLine2 != 'null' ? branchData?.address.addressLine2 : ''} P.O {branchData?.address?.pincode}
          </Typography>
          <Typography variant="body2">{`PH: ${branchData?.phoneNumber},${branchData?.alternatePhoneNumber || ''}`}</Typography>
        </Box>
        <Grid container justifyContent="space-between" mb={1}>
          {/* Left side: Customer Details */}
          <Grid item xs={6}>
            <Box textAlign="left">
              <Typography sx={{ fontSize: '0.875rem' }}>
                To,
              </Typography>
              <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>
                {data.customerName}, {data.phone || ""}
              </Typography>
              <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>
                Site at {data.address}.
              </Typography>

              {/* <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }}>
                Mobile {data}.
              </Typography> */}
            </Box>
          </Grid>

          {/* Right side: Quote No & Date */}
          <Grid item xs="auto">
            <Box textAlign="right">
              <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }} align="left">
                Quote No : {data.quotationNumber}
              </Typography>
              <Typography sx={{ fontSize: '0.875rem', paddingLeft: 2 }} align="left">
                Date : {dateFormat(data.date, 'DD-MM-YYYY')}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Estimation Details */}
        <Box textAlign="center" mb={2} sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Quotation</Typography>
        </Box>

        <Box mb={2}>
          {/* <Typography sx={{ fontSize: '0.875rem' }}>Dear sir/madam</Typography> */}
          <Typography sx={{ fontSize: '0.875rem' }}>
            {data.subject}
          </Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper}>
          <Table size="small" >
            <TableHead>
              {/* Header Row */}
              <TableRow sx={{ bgcolor: 'success.main', }}>
                <TableCell sx={{ fontWeight: 700, color: 'white' }}>
                  <Typography sx={{ fontSize: '0.75rem' }} fontWeight={700}>
                    REQUIRED ITEMS
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{ bgcolor: 'success.main', fontWeight: 700, color: 'white', textAlign: 'center' }}
                  colSpan={3}
                >
                  <Typography sx={{ fontSize: '0.75rem' }} fontWeight={700}>
                    WORK INCLUDED
                  </Typography>
                </TableCell>
              </TableRow>

              {/* Sub Header Row */}
              <TableRow sx={{ bgcolor: 'success.light' }}>
                <TableCell>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                    PARTICULAR
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                    QTY/Sqft
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                    RATE
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                    AMOUNT
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.quotationItems
                .filter((item: any) => item.isIncluded).sort((a: any, b: any) => {
                  const amountA = Number(a.totalPrice);
                  const amountB = Number(b.totalPrice);
                  return amountB - amountA; // Descending order (highest first)
                })
                .map((item: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell>{item.productName}{' '}{item.isPolish !== '2' && (
                      <>({toBoolean(item.isPolish) ? 'With Polish' : 'Without Polish'})</>
                    )}</TableCell>
                    <TableCell align="center"><Typography sx={{ fontSize: '0.75rem' }} >{item.quantity}</Typography></TableCell>
                    <TableCell align="center"><Typography sx={{ fontSize: '0.75rem' }} > {item.unitPrice !== 0 ? Number(item.unitPrice).toFixed(2) : ''}</Typography></TableCell>
                    <TableCell align="center"><Typography sx={{ fontSize: '0.75rem' }} > {item.totalPrice !== 0 ? Number(item.totalPrice).toFixed(2) : ''}</Typography></TableCell>
                  </TableRow>
                ))}

              {/* TOTAL row */}
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}><Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: 'success.main' }} >TOTAL</Typography></TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>

                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>

                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: 'success.main' }} >{totalInluded
                    ? formatIndianCurrency(totalInluded)
                    : '0.00'}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {data.quotationItems.filter((item: any) => !item.isIncluded).length > 0 && (
          (() => {

            const excludedItems = data.quotationItems.filter((item: any) => !item.isIncluded).sort((a: any, b: any) => b.totalPrice - a.totalPrice);
            const hasNonZeroPrices = excludedItems.some((item: any) =>
              item.unitPrice !== 0 || item.totalPrice !== 0
            );

            console.log('excludedItems', excludedItems);
            const showRateColumn = hasNonZeroPrices && excludedItems.some((item: any) => item.unitPrice !== 0);
            const showAmountColumn = hasNonZeroPrices && excludedItems.some((item: any) => item.totalPrice !== 0);
            const showQtyColumn = hasNonZeroPrices && excludedItems.some((item: any) => item.quantity !== 0);

            return (
              <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table size="small">
                  <TableHead>
                    {/* Main Header */}
                    <TableRow sx={{ bgcolor: 'error.main' }}>
                      <TableCell sx={{ fontWeight: 700, color: 'white' }}>
                        <Typography sx={{ fontSize: '0.75rem' }} fontWeight={700}>
                          REQUIRED ITEMS
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          bgcolor: 'error.main',
                          fontWeight: 700,
                          color: 'white',
                          textAlign: 'center',
                          display: 'table-cell'
                        }}
                        colSpan={(showRateColumn ? 1 : 0) + (showAmountColumn ? 1 : 0) + 1} // +1 for QTY column
                      >
                        <Typography sx={{ fontSize: '0.75rem' }} fontWeight={700}>
                          WORK EXCLUDED
                        </Typography>
                      </TableCell>
                      {/* If both rate and amount are hidden, we need to adjust the main header */}
                      {!(showRateColumn || showAmountColumn) && (
                        <TableCell sx={{ bgcolor: 'error.main' }}></TableCell>
                      )}
                    </TableRow>

                    {/* Sub Header */}
                    <TableRow sx={{ bgcolor: 'error.light' }}>
                      <TableCell>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                          PARTICULAR
                        </Typography>
                      </TableCell>
                      <TableCell align="center" sx={{ display: showQtyColumn ? 'table-cell' : 'table-cell' }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                          {showQtyColumn ? "QTY/Sqft" : ""}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ display: showRateColumn ? 'table-cell' : 'table-cell' }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                          {showRateColumn ? "RATE" : ""}
                        </Typography>
                      </TableCell>

                      {showAmountColumn && (
                        <TableCell align="center">
                          <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: 'white' }}>
                            AMOUNT
                          </Typography>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {excludedItems.map((item: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell>{item.productName}</TableCell>
                        {showQtyColumn ? <TableCell align="center">
                          <Typography sx={{ fontSize: '0.75rem' }}>{item.quantity}</Typography>
                        </TableCell> : <TableCell align="center">
                          <Typography sx={{ fontSize: '0.75rem' }}></Typography>
                        </TableCell>}
                        {showRateColumn ? <TableCell align="center">
                          <Typography sx={{ fontSize: '0.75rem' }}>
                            {item.unitPrice !== 0 ? Number(item.unitPrice).toFixed(2) : ''}
                          </Typography>
                        </TableCell> : <TableCell align="center">
                          <Typography sx={{ fontSize: '0.75rem' }}>
                          </Typography>
                        </TableCell>}
                        {showAmountColumn && (
                          <TableCell align="center">
                            <Typography sx={{ fontSize: '0.75rem' }}>
                              {item.totalPrice !== 0 ? Number(item.totalPrice).toFixed(2) : ''}
                            </Typography>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}

                    {/* TOTAL row */}
                    <TableRow sx={{ bgcolor: 'error.lighter' }}>
                      <TableCell sx={{ fontWeight: 700 }}>
                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: 'error.main' }}>
                          TOTAL
                        </Typography>
                      </TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700 }}></TableCell>
                      {showRateColumn && (
                        <TableCell align="center" sx={{ fontWeight: 700 }}></TableCell>
                      )}
                      {showAmountColumn && (
                        <TableCell align="center" sx={{ fontWeight: 700 }}>
                          <Typography sx={{ fontSize: '0.75rem', fontWeight: 900, color: 'error.main' }}>
                            {totalExcluded ? formatIndianCurrency(totalExcluded) : '0.00'}
                          </Typography>
                        </TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            );
          })()
        )}

        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 3, mt: 2 }}>
          <Table size="small">
            <TableHead>
              {/* Header Row */}
              <TableRow sx={{ bgcolor: '#00A300' }}>
                <TableCell sx={{ fontWeight: 700, color: 'white' }} colSpan={4}>
                  <Typography sx={{ fontSize: '0.75rem' }} fontWeight={700}>
                    Total Quotation
                  </Typography>
                </TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              <TableCell sx={{ fontWeight: 700, color: 'green', textAlign: 'right', paddingRight: 7 }} >  {totalAmount
                ? formatIndianCurrency(totalAmount)
                : '0.00'}</TableCell>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Terms and Condtion */}
        {data.termsAndConditions !== "" && <Box mt={1}>
          <Typography sx={{ fontWeight: 700, mb: 1, fontSize: '0.75rem' }}>
            Terms and Conditions.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              pl: 2,
              fontSize: '0.75rem',
              whiteSpace: 'pre-line' // 🔹 respects \n as line breaks
            }}
          >
            {data.termsAndConditions}
          </Typography>
        </Box>}

        {/* Payment Terms */}
        {data?.paymentTerms?.length > 0 && (
          <Box
            mt={1}
            // This prevents splitting across pages
            sx={{
              breakInside: 'avoid',         // modern
              pageBreakInside: 'avoid',     // legacy
              WebkitColumnBreakInside: 'avoid' // Safari
            }}
          >
            <Typography
              sx={{ fontWeight: 700, mb: 1, fontSize: '0.75rem' }}
            >
              Mode of Payment.
            </Typography>

            {/* Remarks */}
            {data?.paymentTerms?.map((item: any, idx: number) => (
              <Typography
                key={idx}
                variant="h6"
                sx={{ marginTop: 0, fontSize: '0.75rem', pl: 2 }}
              >
                <strong>{item?.percentage}%</strong> {item?.description}
              </Typography>
            ))}
          </Box>
        )}

        {/* Footer */}
        <Divider sx={{ my: 3 }} />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
        >
        </Box>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, }}>Selected interlock design</Typography>
        {data.quotationImages?.length > 0 && <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <QuotationImages images={data.quotationImages} />
        </Box>}

        {/* Payment Schedule */}
        {paymentStages?.length > 0 && <><Typography
          variant="h6"
          textAlign="center"
          sx={{ mb: 2, mt: 3, fontWeight: 600, fontSize: '0.875rem' }}
        >
          Payment Schedule
        </Typography>

          <TableContainer
            component={Paper}
            sx={{ borderRadius: 2, boxShadow: 2 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: "primary.light" }}>
                  <TableCell sx={{ fontWeight: 600 }}> <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Description</Typography></TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>
                    <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Amount</Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>
                    {/* <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}> Percentage</Typography> */}
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>
                    <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}> Payable</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentStages.map((stage: any, index: number) => {
                  const { description, percentage } = stage;

                  const payable = percentage
                    ? ((Number(totalIncludedAmount) * percentage) / 100).toFixed(2)
                    : null;

                  return (
                    <TableRow
                      key={index}
                      sx={{ bgcolor: index % 2 ? "grey.100" : "white" }}
                    >
                      <TableCell>
                        <Typography sx={{ fontSize: "0.75rem" }}>{percentage}% {description}</Typography>
                      </TableCell>

                      <TableCell align="center">
                        <Typography sx={{ fontSize: "0.75rem" }}>
                          {totalIncludedAmountFormatted}
                        </Typography>
                      </TableCell>

                      <TableCell align="center">
                        {/* <Typography sx={{ fontSize: "0.75rem" }}>
                        {percentage ? `${percentage}%` : "-"}
                      </Typography> */}
                      </TableCell>

                      <TableCell align="center" sx={{ fontWeight: 600 }}>
                        <Typography sx={{ fontSize: "0.75rem" }}>
                          {payable ? payable.toLocaleString() : "-"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>

            </Table>
          </TableContainer></>
        }

        <Typography
          variant="body2"
          color="error"
          sx={{ mt: 2, textAlign: "center" }}
        >
          *All payments must be made through the provided bank account or Google
          Pay.*
        </Typography>

        {/* Bank Details */}
        <Typography
          variant="h6"
          textAlign="center"
          sx={{ mt: 3, mb: 2, fontWeight: 600, fontSize: '0.875rem' }}
        >
          Bank Details
        </Typography>

        <Grid item container spacing={2}>
          <Grid item sm={12}>
            {renderTable(bank1)}

          </Grid>
        </Grid>
        {/* Footer */}
        <Divider sx={{ my: 3 }} />
        <Box sx={{ flex: 1, textAlign: 'right' }}>
          <Typography sx={{ fontSize: '0.875rem' }}>Thanks & Regards,</Typography>
          <Typography fontWeight="bold" sx={{ fontSize: '0.875rem' }}>JOSEPH PJ</Typography>
          <Typography sx={{ fontSize: '0.875rem' }}>Managing Director</Typography>
          <Typography sx={{ fontSize: '0.875rem' }}>MHB INTERLOCK</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default QPrint;
const QuotationImages = ({ images }: { images: string[] }) => {
  const baseUrl = config.imgUrl; // e.g. "https://yourdomain.com" or from env

  return (
    <ImageList cols={3} gap={8}>
      {images?.map((img, index) => (
        <ImageListItem key={index} sx={{ width: 160, height: 160 }}>
          <img
            src={`${baseUrl}${img}`}
            alt={`Quotation-${index}`}
            loading="lazy"
            style={{
              objectFit: "cover", // or "fill" / "contain" depending on need
              width: "100%",
              height: "100%",
              borderRadius: 8,
              border: "1px solid black",
              cursor: "pointer",
            }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
};
